module.exports = __webpack_public_path__ + "static/img/wjkj.767d2e91.png";